var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.608521,
    y: 0.0209961,
    width: 21.6031,
    height: 21.6031,
    rx: 10.8016,
    fill: "#B73D3D",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4101 15.3593C8.90924 15.3593 6.87342 13.3235 6.87342 10.8227C6.87342 8.32184 8.90924 6.28602 11.4101 6.28602C13.9109 6.28602 15.9467 8.32184 15.9467 10.8227C15.9467 13.3235 13.9109 15.3593 11.4101 15.3593ZM11.4101 5.15186C10.6654 5.15186 9.92796 5.29854 9.23995 5.58352C8.55193 5.86851 7.92679 6.28622 7.4002 6.8128C6.33672 7.87628 5.73926 9.31868 5.73926 10.8227C5.73926 12.3267 6.33672 13.7691 7.4002 14.8325C7.92679 15.3591 8.55193 15.7768 9.23995 16.0618C9.92796 16.3468 10.6654 16.4935 11.4101 16.4935C12.9141 16.4935 14.3565 15.896 15.4199 14.8325C16.4834 13.7691 17.0809 12.3267 17.0809 10.8227C17.0809 10.078 16.9342 9.34056 16.6492 8.65254C16.3642 7.96453 15.9465 7.33938 15.4199 6.8128C14.8934 6.28622 14.2682 5.86851 13.5802 5.58352C12.8922 5.29854 12.1548 5.15186 11.4101 5.15186ZM8.57467 11.3898H14.2455V10.2556H8.57467",
    fill: "#B73D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurned);
export default __webpack_public_path__ + "static/media/churned.474a7debb73f02380e8fae80939ee36b.svg";
export { ForwardRef as ReactComponent };